import React from 'react';
import { Accent, Text } from '@nerdwallet/currency';
import { Impression } from '@nerdwallet/analytics/react/impression';
import styles from './our-take-highlight.module.less';
import { BANNER_TEXT } from './constants';

var OurTakeHighlight = function OurTakeHighlight(_ref) {
  var bannerType = _ref.bannerType,
      content = _ref.content,
      analytics = _ref.analytics;

  if (!bannerType || !content || !BANNER_TEXT[bannerType]) {
    return null;
  }

  var component = /*#__PURE__*/React.createElement("div", {
    className: styles.ourTakeWrapper
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.banner
  }, /*#__PURE__*/React.createElement(Accent, {
    size: "small"
  }, BANNER_TEXT[bannerType])), /*#__PURE__*/React.createElement(Text, {
    size: "small"
  }, content));
  return analytics ? /*#__PURE__*/React.createElement(Impression, {
    enabled: true,
    eventType: "element_impression",
    entityName: analytics === null || analytics === void 0 ? void 0 : analytics.entityName,
    payload: {
      section_name: analytics === null || analytics === void 0 ? void 0 : analytics.sectionName
    }
  }, component) : component;
};

export default OurTakeHighlight;